<template>
  <div class="fileConvert">
    <input id="inputElement" name="file" type="file" accept="application/pdf">
    <el-button size="small" type="primary" :loading="uploadLoading" @click="upload">PDF转EXCEL</el-button>
  </div>
</template>

<script>

  export default {
    name: "FileConvert",
    components: {},
    data() {
      return {
        uploadUrl: window.config.basicServerHttpUrl + "sd/so/pdfConvert2Xls",
        uploadLoading: false,
      };
    },
    mounted() {
    },
    methods: {
      upload() {
        let formData = new FormData();
        let inputElement = document.getElementById("inputElement");
        let file = inputElement.files[0];
        if (!file) {
          this.$message.error("未选择文件");
          return;
        }
        this.uploadLoading = true;
        formData.append("file", file);
        let config = {
          headers: {"Content-Type": "multipart/form-data"},
          responseType: "blob",
        };
        this.$axios.post(this.uploadUrl, formData, config).then(res => {
          this.uploadLoading = false;
          let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
          let fileName = "物料信息.xls";
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        }).catch(() => {
          this.uploadLoading = false;
          this.$message.error("未知错误");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .fileConvert {
  }
</style>
